module.exports = "<div class=\"_user-detail-view\">\n\n  <v-layout row justify-center>\n\n    <v-flex xs12>\n      <transition name=\"fade\">\n        <cm-installer-details></cm-installer-details>\n      </transition>\n    </v-flex>\n\n  </v-layout>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/installerDetailView/installerDetailView.vue
// module id = 395
// module chunks = 0